/**
 * True when `href` is an absolute URL whose host differs from `homeDomain` —
 * i.e. the link leaves the consuming app's own host. A subdomain (e.g.
 * `ideas.fin.ai` under `fin.ai`) counts as off-host and returns true; a path on
 * the same host (`fin.ai/help`) returns false. Relative hrefs return false too.
 * `homeDomain` is supplied per app, keeping this package domain-agnostic.
 */
export const isOffDomain = (href: string, homeDomain?: string): boolean => {
  if (!homeDomain || !/^https?:\/\//i.test(href)) return false;
  let host: string;
  try {
    host = new URL(href).hostname.replace(/^www\./, "");
  } catch {
    return false;
  }
  return host !== homeDomain.replace(/^www\./, "");
};
